<template>
  <v-application v-if="access.item_mxik_search">
    <v-settings>
      <v-row rounded outlined class="ma-0 pa-0">
        <v-spacer></v-spacer>
        <v-btn class="ma-1" style="">
          <v-icon @click="searchAppend()">mdi-magnify</v-icon>
        </v-btn>
        <v-text-field
          v-model="searchValue"
          v-on:keyup.enter="searchMxik"
          ref="search_field"
          v-if="searchText"
          autofocus
          class="mt-3 pa-0"
          clearable
          @click:append="searchAppend()"
          label="Search"
        />
      </v-row>
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('group_name_uz')"
        v-model="items.group_name_uz"
      />
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('class_name_uz')"
        v-model="items.class_name_uz"
      />
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('position_uz')"
        v-model="items.position_uz"
      />
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('barcode')"
        v-model="items.barcode"
      />
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('mxik')"
        v-model="items.mxik"
      />
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('sub_position_uz')"
        v-model="items.sub_position_uz"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('brand')"
        disabled
        v-model="items.brand"
      />
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('attribute_uz')"
        v-model="items.attribute_uz"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('unit')"
        disabled
        v-model="items.unit"
      />
      <v-text-field
        class="pl-5 pr-5"
        disabled
        :label="$t('unit_of_pack')"
        v-model="items.unit_of_pack"
      />
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
export default {
  data: () => ({
    items: {
      barcode: "",
      mxik: "",
      group_name_uz: "",
      class_name_uz: "",
      position_uz: "",
      sub_position_uz: "",
      brand: "",
      attribute_uz: "",
      unit: 0,
      unit_of_pack: "",
    },
    searchValue: "",
    searchText: true,
  }),

  methods: {
    async searchMxik() {
      const res = await this.$communicator("mxik_get", {
        params: [this.searchValue],
      });
      this.items = res?.data?.data;
    },
    searchAppend() {
      this.searchText = true;
      this.searchMxik();
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
